import { Chat } from '@/config'
import { Getstream } from '@/services'
import { waitFor } from '@codeleap/utils'
import { ChatLocalMesage, getFreshMessage } from '@packages/chat'
import { useChannelActionContext } from 'stream-chat-react'

export const useThreadNavigation = () => {
  const actions = useChannelActionContext()

  async function openThread(parentMessage: ChatLocalMesage, messageId?: string) {
    if (!parentMessage) return
    const chatClient = await Getstream.Chat.getChatClient()
    const freshMessage = await getFreshMessage(chatClient, parentMessage)

    Chat.Store.setThread(freshMessage)
    actions.openThread(freshMessage)

    if (messageId) {
      await waitFor(1)
      actions.jumpToMessage(messageId)
    }
  }

  function closeThread() {
    try {
      const thread = Chat.Store.getThread()
      Chat.Store.setMessageToScroll(thread)
      Chat.Store.setThread(null)
      actions.closeThread()
    } catch (e) {
      console.error('Error closing thread:', e)
    }
  }

  return { jumpToMessage: actions.jumpToMessage, openThread, closeThread }
}
